import type { ListItemField } from '@openx/components-core/lib/List/filters/ListItemFieldsFilter/ListItemFieldsFilter';
import { FieldValue } from '@openx/components-core/lib/SearchTransferList/components/FieldValue';
import type { UseSeatTransferListFieldsReturnType } from '@openx/components-core/lib/SearchTransferList/variants/SeatTransferList/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDemandPartnerOptionsFetch } from '../../../hooks/useDemandPartnerOptionsFetch';
import type { CuratedDealBuyerDiscountSeat } from '../../types';

export const useSeatTransferListFields = (): UseSeatTransferListFieldsReturnType<CuratedDealBuyerDiscountSeat> => {
  const { isLoading, mapById } = useDemandPartnerOptionsFetch();
  const { t } = useTranslation();

  const fieldsConfig = useMemo<ListItemField<CuratedDealBuyerDiscountSeat>[]>(
    () => [
      {
        displayName: t('Received Seat ID'),
        id: 'seat_id',
        render: ({ seat_id }, searchPhrase) => (
          <FieldValue name={t('Received Seat ID')} searchPhrase={searchPhrase} value={seat_id} />
        ),
      },
      {
        displayName: t('DSP'),
        id: 'demand_partner_id',
        render: ({ demand_partner_id }) => (
          <FieldValue name={t('DSP')} value={mapById[demand_partner_id]?.name || demand_partner_id} />
        ),
      },
      {
        displayName: t('Owner'),
        id: 'holding',
        render: ({ buyer_path }) => <FieldValue name={t('Owner')} value={buyer_path.at(-1)?.name} />,
      },
    ],
    [mapById, t]
  );

  return { fieldsConfig, isLoading };
};
